import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { startAnalytics, trackPageView } from '../../lib/analytics.js';
import { setCanonical } from '../../lib/seo.js';

/**
 * 주소가 바뀔 때마다 **정본 주소를 다시 못 박고 방문을 기록한다.**
 *
 * 화면을 그리지 않는다(`null`) — 하는 일이 부수 효과뿐이라 자리를 차지할
 * 이유가 없다. 라우터 **안**에 있어야 `useLocation`이 보인다.
 *
 * ⚠️ 제목은 **한 박자 늦게** 읽는다. 공개 프로필은 사람 정보를 받아 온 뒤에
 * 제목을 바꾸는데, 여기서 바로 읽으면 바뀌기 전의 제목이 통계에 남는다.
 * 한 프레임 뒤로 미루면 그 사이에 바뀐 제목이 잡힌다.
 */
export function PageTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    startAnalytics();
  }, []);

  useEffect(() => {
    setCanonical(pathname);
    const timer = setTimeout(() => trackPageView(pathname, document.title), 0);
    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
}
